import type { ReactNode } from 'react';
import type { CustomerPaymentMethodId } from '../shop/presenters/shopCheckoutPresenter.js';

export const SIMPLE_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/u;

export type ProductPaymentRailUiStep = 'primary' | 'gateway-methods';

export function resolvePaymentMethodTestId(id: CustomerPaymentMethodId): string {
  if (id === 'QR') {
    return 'customer-payment-method-qr';
  }
  if (id === 'CARD') {
    return 'customer-payment-method-card';
  }
  if (id === 'CASH') {
    return 'customer-payment-method-cash';
  }
  return 'customer-payment-method-wallet';
}

export function CheckoutGatewayRedirectLink({
  children,
  to,
}: {
  children?: ReactNode;
  to: string;
}): JSX.Element {
  return (
    <a className="underline" href={to}>
      {children}
    </a>
  );
}
